// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__26G7t","top":"styles_top__21BJV","left":"styles_left__1Vouf","description":"styles_description__2SwTY"};